// CRM and Company type definitions

export const PipelineStages = {
  PROSPECT: "Prospect",
  QUALIFIED: "Qualified", 
  TRIAL: "Trial",
  CLOSED_WON: "Closed Won",
  CLOSED_LOST: "Closed Lost"
};

export const ActivityTypes = {
  CALL: "Call",
  EMAIL: "Email", 
  MEETING: "Meeting",
  DEMO: "Demo",
  SITE_VISIT: "Site Visit"
};

export const ActivityOutcomes = {
  NO_RESPONSE: "No Response",
  POSITIVE: "Positive",
  NEUTRAL: "Neutral", 
  NEGATIVE: "Negative"
};

export const AtRiskReasons = {
  LOW_ORDERS: "Low Orders",
  NO_ACTIVITY: "No Activity",
  CONTRACT_EXPIRING: "Contract Expiring",
  QUALITY_ISSUE: "Quality Issue"
};

export const RiskLevels = {
  LOW: "Low",
  MEDIUM: "Medium", 
  HIGH: "High"
};

export const CompanyTiers = {
  ENTERPRISE: "Enterprise",
  PREMIUM: "Premium",
  STANDARD: "Standard"
};

export const CompanyStatuses = {
  ACTIVE: "Active",
  AT_RISK: "At Risk"
};

export const ClinicStatuses = {
  ACTIVE: "Active",
  DORMANT: "Dormant", 
  NEW: "New"
};

export const ContractStatuses = {
  ACTIVE: "Active",
  EXPIRING: "Expiring",
  EXPIRED: "Expired"
};

export const FileTypes = {
  PDF: "pdf",
  IMAGE: "image", 
  DOC: "doc"
};
